import {
  PrivacyRightsMainComponentStateType,
  PrivacyRightsMainComponentActionType,
} from './PrivacyRightsMainComponentReducer.types';

export const getPrivacyRightsMainComponentInitialState = (
  initiallyPreSelectedTabValue: string
): PrivacyRightsMainComponentStateType => {
  return {
    selectedStateOrLoggedInUserStateCode: 'NA',
    isUsStateAndBelongToCpraGroups: true,
    showFormResetConfirmationModal: false,
    selectedTab: initiallyPreSelectedTabValue,
    userName: null,
  };
};

export const privacyRightsMainComponentReducer = (
  state: PrivacyRightsMainComponentStateType,
  action: PrivacyRightsMainComponentActionType
): PrivacyRightsMainComponentStateType => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_SELECTED_STATE':
      return { ...state, selectedStateOrLoggedInUserStateCode: payload };
    case 'SET_SHOW_FORM_RESET_CONFIRMATION_MODAL':
      return { ...state, showFormResetConfirmationModal: payload };
    case 'SET_MULTIPLE_PRIVACY_RIGHTS_STATES':
      return { ...state, ...payload };
    default:
      throw new Error(`Invalid action type: ${type}`);
  }
};
